import React from 'react';
import { number } from 'prop-types';

import { EvaluatedDollar, EvaluatedPercent } from '../../shared/Text/Text';

import ValueIndicator from 'components/shared/ValueIndicator/ValueIndicator';

const DailyChange = ({ difference, percentChange }) => (
  <td className="daily-change">
    <span>
      <span>
        <EvaluatedDollar element="div">{difference}</EvaluatedDollar>
        <EvaluatedPercent className="e2e-daily-change-percent" element="div">
          {percentChange}
        </EvaluatedPercent>
      </span>
      <ValueIndicator value={difference} />
    </span>
  </td>
);

DailyChange.propTypes = {
  difference: number,
  percentChange: number
};

export const DailyChangeSingleCell = ({ difference, percentChange }) => [
  <EvaluatedDollar
    key="daily-dollar"
    className="e2e-daily-change-dollar"
    element="td"
  >
    {difference}
  </EvaluatedDollar>,
  <td key="daily-percent">
    <EvaluatedPercent className="e2e-daily-change-percent">
      {percentChange}
    </EvaluatedPercent>
    <ValueIndicator value={percentChange} />
  </td>
];

export default DailyChange;
